/** Which end of the ranking a pivot value filter keeps. */
export enum PivotValueFilterDirectionEnum {
  top = 'top',
  bottom = 'bottom',
}
